export default __webpack_public_path__ + "static/media/easil-loader.4756f5d0.gif";